import {on} from '@ngrx/store';
import * as PlayerActions from './player.actions';
import {loadInvitesSuccess, loadPlayerSuccess} from './player.actions';
import {Invite, Player} from 'gamesis-story-client';
import {createRehydrateReducer} from '../rehydrate.reducer';
import {exitCampaign} from '../campaigns/campaign.actions';
import {unauthenticated} from '../app/app.actions';

export interface PlayerState {
    players: Player[];
    invites: Invite[];
    me: Player;
    loading: boolean;
    error: any;
}

const initialState: PlayerState = {
    players: [],
    invites: [],
    me: undefined,
    loading: false,
    error: null,
};

const _playerReducer = createRehydrateReducer(
    'players',
    initialState,
    on(PlayerActions.loadPlayers, state => ({...state, loading: true})),
    on(PlayerActions.loadPlayersSuccess, (state, {players}) => ({
        ...state,
        players
    })),
    on(PlayerActions.loadInvitesSuccess, (state, {invites}) => ({
        ...state,
        invites
    })),
    on(PlayerActions.loadPlayerSuccess, (state, {player}) => ({
        ...state,
        me: player
    })),
    on(PlayerActions.loadPlayersSuccess, loadInvitesSuccess, loadPlayerSuccess, (state) => ({
        ...state,
        loading: false,
        error: null
    })),
    on(PlayerActions.playerFailure, (state, {error}) => ({...state, loading: false, error})),
    on(exitCampaign, unauthenticated, (state) => initialState),
);

export function playerReducer(state, action) {
    return _playerReducer(state, action);
}
